import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { transportProviderAPI } from '../../services/api';

const STATUS_LABELS = {
  payment_pending:   { label: 'بانتظار الدفع', color: 'bg-gray-100 text-gray-600' },
  payment_submitted: { label: 'إيصال قيد المراجعة', color: 'bg-amber-100 text-amber-700' },
  payment_confirmed: { label: 'بانتظار تعيين مركبة', color: 'bg-blue-100 text-blue-700' },
  vehicle_assigned:  { label: 'بانتظار الاستلام', color: 'bg-indigo-100 text-indigo-700' },
  picked_up:         { label: 'تم الاستلام', color: 'bg-purple-100 text-purple-700' },
  in_transit:        { label: 'في الطريق', color: 'bg-purple-100 text-purple-700' },
  delivered:         { label: 'تم التسليم', color: 'bg-emerald-100 text-emerald-700' },
  completed:         { label: 'مكتمل', color: 'bg-emerald-100 text-emerald-700' },
  cancelled:         { label: 'ملغى', color: 'bg-red-100 text-red-700' },
};

const TransportProviderOrdersPage = () => {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    transportProviderAPI.getOrders()
      .then((res) => setOrders(res.data.data || []))
      .catch(() => toast.error('فشل في تحميل الطلبات'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    let interval = setInterval(load, 15000);
    const handleVisibility = () => {
      if (document.hidden) {
        clearInterval(interval);
      } else {
        load();
        interval = setInterval(load, 15000);
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  return (
    <div dir="rtl" className="p-4 sm:p-6">
      <h1 className="text-xl font-black text-gray-800 mb-6">🚚 طلباتي</h1>

      {loading ? (
        <div className="text-center text-gray-400 py-16">جاري التحميل...</div>
      ) : orders.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-10 text-center text-gray-400">لا توجد طلبات بعد</div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 text-right font-bold text-gray-600">رقم الطلب</th>
                  <th className="px-4 py-3 text-right font-bold text-gray-600">المسار</th>
                  <th className="px-4 py-3 text-right font-bold text-gray-600">السعر</th>
                  <th className="px-4 py-3 text-right font-bold text-gray-600">الحالة</th>
                  <th className="px-4 py-3 text-right font-bold text-gray-600"></th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {orders.map((o) => (
                  <tr key={o.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono text-xs text-gray-700">{o.orderNumber}</td>
                    <td className="px-4 py-3 text-gray-700">{o.request?.fromLabel} ← {o.request?.toLabel}</td>
                    <td className="px-4 py-3 font-bold text-gray-800">{o.providerReceivable} ج.س</td>
                    <td className="px-4 py-3">
                      <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${STATUS_LABELS[o.status]?.color || 'bg-gray-100 text-gray-600'}`}>
                        {STATUS_LABELS[o.status]?.label || o.status}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <Link to={`/transport-provider/orders/${o.id}`} className="text-blue-700 hover:underline text-xs font-semibold">التفاصيل</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransportProviderOrdersPage;
export { STATUS_LABELS as TRANSPORT_ORDER_STATUS_LABELS };
